import { object, string } from 'yup'

import { CloseAccountReason } from 'generated/types'
import { requestCloseAccountConfirmedFields } from 'pages/settings/my-subscription/segment'

type Props = {
  isWebView: boolean
  hasLaterAccount: boolean
  hasSpendAccount: boolean
  hasLaterBalance: boolean
  shuffledReasons: CloseAccountReason
}
export interface FormValues {
  comments: string
  reason: string
}

export const validationSchema = object().shape({
  comments: string().nullable(true),
  reason: string().required(),
})

export const handleSubmit = (
  values,
  {
    props: {
      analytics,
      isWebView,
      history,
      location,
      hasLaterAccount,
      hasSpendAccount,
      hasLaterBalance,
      shuffledReasons,
    },
  },
) => {
  analytics.track('Button Tapped', requestCloseAccountConfirmedFields(values))
  const findLabel = (selection: {
    label: CloseAccountReason['label']
    value: CloseAccountReason['key']
  }) => {
    return selection.value === values.reason
  }
  const userSelection: {
    label: CloseAccountReason['label']
    value: CloseAccountReason['key']
  } = shuffledReasons.find(findLabel)

  sessionStorage.setItem('closureFormComment', values.comments)
  sessionStorage.setItem('closureFormReason', userSelection.label)
  sessionStorage.setItem('closureFormReasonKey', values.reason)
  if (hasLaterBalance) {
    const url = isWebView ? '/wv/close-account/later' : '/close-account/later'
    history.push(url, {
      referrer: location.pathname,
      hasLaterAccount,
      hasSpendAccount,
      isCancelSubscriptionFlow: true,
      closureFormReason: userSelection.label,
      closureFormComment: values.comments,
    })
  } else {
    const url = isWebView ? '/wv/cancel-subscription' : '/cancel-subscription'
    history.push(url, {
      shouldShowClosureConfirmationScreen: true,
      isCancelSubscriptionFlow: true,
      hasLaterAccount,
      hasSpendAccount,
      closureFormReason: userSelection.label,
      closureFormComment: values.comments,
      closureFormKey: values.reason,
    })
  }
}

export const mapPropsToValues = (props) => {
  const { comments = '', reason = '' } = props

  return {
    comments,
    reason,
  }
}
